import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { Type } from "@angular/core";
import { IDiagnosis } from "../../../configuration/diagnosis/model/diagnosis.model";
import { IPolicy } from "../../../policy/policy-and-product/models/policy-and-product.model";
import { IBeneficiary } from "../../../beneficiary/models/beneficiary.model";
import { IProviderList } from "../../../provider/models/provider.model";
import { IServiceCode } from "../../../configuration/service-code/models/service-code.model";
import { ApprovalType } from "../../../../../../shared/constants/apporval-type-enum";

export const managePreAuthRequestConfig = {
  entityName: "PREAUTH.PREAUTH_TRANSACTION.APPROVAL",
  BASIC_INFO_TITLE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.TITLE",
  BENEFICIARY_INFO: "PREAUTH.PREAUTH_PROCESS.BENEFICIARY_INFO",
  CLAIM_TITLE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.CLAIM_TITLE",
  CARE_TEAM_TITLE: "PREAUTH.PREAUTH_REQUEST.CARE_TEAM.TITLE",
  CARE_TEAM: "PREAUTH.PREAUTH_REQUEST.CARE_TEAM.CARE_TEAM",
  DIAGNOSIS_TITLE: "PREAUTH.PREAUTH_REQUEST.DIAGNOSIS.TITLE",
  ATTACHMENT_TITLE: "PREAUTH.PREAUTH_REQUEST.ATTACHMENTS.TITLE",
  SUPPORTING_INFO_TITLE: "PREAUTH.PREAUTH_REQUEST.SUPPORTING_INFO.TITLE",
  REJECT_COMMUNICATION: "PREAUTH.COMMUNICATION.REJECT_COMMUNICATION",
  INFO: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.INFO",
  SEARCH_BENEFICIAY: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.SEARCH_BENEFICIAY",
  NEW_BORN: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.NEW_BORN",
  RELATED_PREAUTH_REFERENCE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.RELATED_PREAUTH_REFERENCE",
  RELATED_CLAIM_REFERENCE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.RELATED_CLAIM_REFERENCE",
  PREAUTH_REFERENCE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PREAUTH_REFERENCE",
  REFERRAL_CLAIM_REFERENCE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.REFERRAL_CLAIM_REFERENCE",
  REFERRAL_PREAUTH_REFERENCE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.REFERRAL_PREAUTH_REFERENCE",
  STREET_NAME: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.STREET_NAME",
  DATE_ORDERED: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.DATE_ORDERED",
  TYPE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.TYPE",
  SUB_TYPE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.SUB_TYPE",
  PREAUTH_DATE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PREAUTH_DATE",
  REFERRING_PROVIDER: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.REFERRING_PROVIDER",
  ACCIDENT_TYPE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ACCIDENT_TYPE",
  ACCIDENT: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ACCIDENT",
  ACCIDENT_DATE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ACCIDENT_DATE",
  MORE_DETAILS: "COMMON.MORE_DETAILS",
  CHANGE_POLICY: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.CHANGE_POLICY",
  SELECT_POLICY: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.SELECT_POLICY",
  SEARCH_PRACTITIONER: "PREAUTH.PREAUTH_REQUEST.CARE_TEAM.PRACTITIONER.PRACTITIONER",
  CARE_TEAM_ROLE: "PREAUTH.PREAUTH_REQUEST.CARE_TEAM.ROLE",
  REQUEST_AUTH: "COMMON.FINAL_SAVE",
  REQUEST_AUTH_DRAFT: "PREAUTH.PREAUTH_REQUEST.REQUEST_AUTHORIZATION_DRAFT",
  REQUEST_MRE: "PREAUTH.PREAUTH_REQUEST.REQUEST_MRE",
  SAVE_REQUEST_MRE: "PREAUTH.PREAUTH_REQUEST.SAVE_REQUEST_MRE",
  ITEMS_TITLE: "PREAUTH.PREAUTH_REQUEST.ITEMS.TITLE",
  INVOICE_NO: "PREAUTH.PREAUTH_REQUEST.ITEMS.INVOICE_NO",
  BODY_SITE: "CONFIGURATION.MASTER_DATA.BODY_SITE.TITLE",
  SUPPORTING_INFO: "PREAUTH.PREAUTH_PROCESS.SUPPORTING_INFO",
  SUB_SITE: "PREAUTH.PREAUTH_PROCESS.SUB_SITE",
  CODE: "FORM_FIELD.CODE",
  SERVICE_START_DATE: "PREAUTH.PREAUTH_PROCESS.SERVICE_START_DATE",
  SERVICE_END_DATE: "PREAUTH.PREAUTH_PROCESS.SERVICE_END_DATE",
  CODE_DESCRIPTION: "PREAUTH.PREAUTH_REQUEST.ITEMS.CODE_DESCRIPTION",
  DETAIL_CODE: "PREAUTH.PREAUTH_REQUEST.ITEMS.DETAIL_CODE",
  PHARMACIST_SELECTION_REASON: "PREAUTH.PREAUTH_REQUEST.ITEMS.PHARMACIST_SELECTION_REASON",
  PRESCRIBED_MEDICATION: "PREAUTH.PREAUTH_REQUEST.ITEMS.PRESCRIBED_MEDICATION",
  PHARMACIST_SUBSTITUTE_REASON: "PREAUTH.PREAUTH_REQUEST.ITEMS.PHARMACIST_SUBSTITUTE_REASON",
  DISCOUNT_AMOUNT: "PREAUTH.PREAUTH_PROCESS.DISCOUNT_AMOUNT",
  QUANTITY: "PREAUTH.PREAUTH_PROCESS.QUANTITY",
  ELIGIBILITY: {
    DETAILS: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ELIGIBILITY.DETAILS",
    RESPONSE_VALUE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ELIGIBILITY.RESPONSE_VALUE",
    RESPONSE_URL: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ELIGIBILITY.RESPONSE_URL",
    ID: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ELIGIBILITY.ID",
    DATE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ELIGIBILITY.DATE"
  },
  PREAUTH_DETAILS: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PREAUTH_DETAILS",
  PREAUTH_IDENTIFIER_VALUE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PREAUTH_IDENTIFIER_VALUE",
  PREAUTH_IDENTIFIER_URL: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PREAUTH_IDENTIFIER_URL",
  PREAUTH_REFERENCE_ID: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PREAUTH_REFERENCE_ID",
  EPISODE_NO: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.EPISODE_NO",
  ACCOUNTING_PERIOD: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ACCOUNTING_PERIOD",
  STATUS: "FORM_FIELD.STATUS",
  CLASS: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.CLASS",
  SERVICETYPE: "CONFIGURATION.SERVICE_TYPE.TITLE",
  PRIORITY: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PRIORITY",
  START_DATE: "FORM_FIELD.START_DATE",
  END_DATE: "FORM_FIELD.END_DATE",
  SERVICE_EVENT_TYPE: "ENTITY_TYPE_LIST.SERVICE_EVENT_TYPE",
  CAUSE_OF_DEATH: "ENTITY_TYPE_LIST.CAUSE_OF_DEATH",
  ORIGIN: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ORIGIN",
  ADMIT_SOURCE: "ENTITY_TYPE_LIST.ADMIT_SOURCE",
  RE_ADMISSION: "ENTITY_TYPE_LIST.RE_ADMISSION",
  DISCHARGE_DISPOSITION: "ENTITY_TYPE_LIST.DISCHARGE_DISPOSITION",
  EMERGENCY_ARRIVAL_CODE: "ENTITY_TYPE_LIST.EMERGENCY_ARRIVAL_CODE",
  EMERGENCY_SERVICE_START: "ENTITY_TYPE_LIST.EMERGENCY_SERVICE_START",
  EMERGENCY_DISCHARGE_DISPOSITION: "ENTITY_TYPE_LIST.EMERGENCY_DISCHARGE_DISPOSITION",
  TRIAGE_CATEGORY: "ENTITY_TYPE_LIST.TRIAGE_CATEGORY",
  TRIAGE_DATE: "ENTITY_TYPE_LIST.TRIAGE_DATE",
  INTENDED_LENGTH_OF_STAY: "PREAUTH.PREAUTH_REQUEST.SUPPORTING_INFO.INTENDED_LENGTH_OF_STAY",
  ADMISSION_SPECIALTY: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ADMISSION_SPECIALTY",
  DISCHARGE_SPECIALTY: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.DISCHARGE_SPECIALTY",
  DATE_WRITTEN: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.DATE_WRITTEN",
  PRESCRIBER: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PRESCRIBER",
  VISION_PRESCRIPTION: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.VISION_PRESCRIPTION",
  LENS_SPECIFICATIONS: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.LENS_SPECIFICATIONS",
  PRODUCT: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PRODUCT",
  COLOR: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.COLOR",
  BRAND: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.BRAND",
  POWER: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.POWER",
  BACK_CURVE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.BACK_CURVE",
  DIAMETER: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.DIAMETER",
  CYLINDER: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.CYLINDER",
  AXIS: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.AXIS",
  ADD: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ADD",
  DURATION: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.DURATION",
  NOTES: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.NOTES",
  PRISM: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PRISM",
  SPHERE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.SPHERE",
  BASE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.BASE",
  LEFT: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.LEFT",
  RIGHT: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.RIGHT",
  ADD_LENS: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ADD_LENS",
  EDIT_LENS: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.EDIT_LENS",
  PRESCRIPTION_REERENCE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.PRESCRIPTION_REERENCE",
  OTHER_REASON: "PREAUTH.PREAUTH_REQUEST.ITEMS.OTHER_REASON",
  DISPLAY: "FORM_FIELD.DISPLAY",
  PATIENT_SHARE_AMOUNT_TOOLTIP: "PREAUTH.PREAUTH_PROCESS.PATIENT_SHARE_AMOUNT",
  DISCOUNT_TOOLTIP: "PREAUTH.PREAUTH_PROCESS.DISCOUNT_TOOLTIP",
  UNIT_PRICE_TOOLTIP: "PREAUTH.PREAUTH_PROCESS.UNIT_PRICE_TOOLTIP",
  DISABLE_TOOLTIP_FOR_TAB: "PREAUTH.PREAUTH_REQUEST.TAB_DISABLE_TOOLTIP",
  DATE_ORDERED_DISABLE_TOOLTIP_FOR_TAB: "PREAUTH.PREAUTH_REQUEST.DATE_ORDERED_TAB_DISABLE_TOOLTIP",
  ENCOUNTER: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.ENCOUNTER",
  ABSENCE_OF_SCIENTIFIC_CODE: "ENTITY_TYPE_LIST.ABSENCE_OF_SCIENTIFIC_CODE",
  STRENGTH: "FORM_FIELD.STRENGTH",
  DAYSOFSUPPLY: "PRESCRIPTION.PRESCRIPTION_REQUEST.DAYS_OF_SUPPLY",
  AUTHORED_ON: "PRESCRIPTION.PRESCRIPTION_REQUEST.AUTHORED_ON",
  REQUEST_PRESCRIPTION: "COMMON.FINAL_SAVE",
  REFERRAL_PRESCRIPTION_REFERENCE: "PREAUTH.PREAUTH_REQUEST.BASIC_INFO.REFERRAL_PRESCRIPTION_REFERENCE"
};

export interface ItemAmountDetail {
  net: number,
  factor: number,
  patientShareAmount: number,
  payerShareAmount: number
}

type Primitive = string | number | boolean | null | undefined;

type ToFormControls<T> = {
  [K in keyof T]: T[K] extends Array<infer U>
  ? U extends Primitive
  ? FormArray<FormControl<U>>
  : FormArray<FormGroup<ToFormControls<U>>>
  : T[K] extends Primitive
  ? FormControl<T[K]>
  : FormGroup<ToFormControls<T[K]>>;
};

export type ApprovalForm = ToFormControls<IApproval>;
export type ApprovalAccident = ToFormControls<IApprovalAccidentDetail>;
export type ApprovalEncounterInfo = ToFormControls<IApprovalEncounterInfo>;
export type ApprovalHospitalizationInfo = ToFormControls<IApprovalHospitalizationInfo>;
export type ApprovalEmergencyInfo = ToFormControls<IApprovalEmergencyInfo>;

export interface IApproval {
  birthWeight?: string;
  estimatedLengthOfStay?: string;
  info?: string;
  lastMenstrualPeriod?: string;
  morphology?: string;
  oldReferenceNo?: string;
  PastMedicalAndSurgicalHistory?: string;
  physicalExamination?: string;
  reasonForVisit?: string;
  reasonForVisitNameArabic?: string;
  reasonForVisitNameEnglish?: string;
  statusNameArabic?: string;
  statusNameEnglish?: string;
  subTypeNameArabic?: string;
  subTypeNameEnglish?: string;
  treatmentPlan?: string;
  typeNameArabic?: string;
  typeNameEnglish?: string;
  visionPrescPhysicianNameArabic?: string;
  visionPrescPhysicianNameEnglish?: string;
  approvalRequestId?: string
  isReferral?: boolean;
  preAuthIdentifierResponsevalue?: string;
  preauthDate?: string;
  preAuthIdentifierResponseUrl?: string;
  preauthReferenceNo?: string;
  preauthBeneficiaryId?: string;
  preauthBeneficiaryFullName?: string;
  episodeNo?: string;
  preauthDetails?: string;
  accountingPeriod?: string;
  isNewborn?: boolean
  beneficiaryId?: string
  policyId?: string
  dateOrdered?: string
  typeId?: string
  subTypeId?: string
  eligibilityType?: string
  eligibilityResponseUrl?: string
  eligibilityResponseValue?: string
  eligibilityId?: string
  eligibilityDate?: string
  relatedReferenceNos?: RelatedRefNo[]
  referenceNo?: string
  providerId?: string
  referralProviderId?: string
  prescriptionReferenceNo?: string
  prescriptionReferenceId?: string
  isAccidentRequest?: boolean
  isClaimActive?: boolean
  isPaymentCreated?: boolean
  statusId?: string
  reasonNoteId?: string
  visionPrescDateWritten?: string
  visionPrescPhysicianId?: string
  approvalPeriodStartDate?: string
  approvalPeriodEndDate?: string
  requestBundleId?: string
  responseBundleId?: string
  totalNet?: number | null
  totalTax?: number | null
  totalPatientShare?: number | null
  totalPayerShare?: number | null
  totalDiscount?: number
  deleted?: boolean
  createdBy?: string
  createdDate?: string
  lastUpdatedBy?: string
  lastUpdatedDate?: string
  deletedBy?: string
  deletedDate?: string
  approvalCareTeams?: IApprovalCareTeam[]
  approvalDiagnosis?: IApprovalDiagnosis[]
  approvalSupportingInfos?: IApprovalSupportingInfo[]
  approvalSupportingInfoLabTests?: IApprovalSupportingInfoLabTest[]
  approvalSupportingInfoDiagnosis?: IApprovalSupportingInfoDiagnosis[]
  approvalAccidentDetail?: IApprovalAccidentDetail
  approvalVisionPrescriptions?: IApprovalVisionPrescription[]
  approvalEncounterInfo?: IApprovalEncounterInfo
  approvalHospitalizationInfo?: IApprovalHospitalizationInfo
  approvalEmergencyInfo?: IApprovalEmergencyInfo
  approvalItems?: IApprovalItem[]
  approvalReasonNotes?: ApprovalReasonNote[];
  policy?: Partial<IPolicy>
  beneficiary?: Partial<IBeneficiary>
  provider?: Partial<IProviderList>;
  referralProvider?: Partial<IProviderList>;
  eligibilityTypeNameEnglish?: string;
  eligibilityTypeNameArabic?: string;
  relatedRefNos?: RelatedRefNo[],
  assignedBy?: string,
  assignedTo?: string,
  assignedToName?: string,
  assignedDate?: string,
  approvalProcessedBy?: string,
  approvalProcessedDate?: string,
  referralApprovalId?: string,
  referralReferenceNo?: string,
  referralBeneficiaryName?: string,
  approvalReuseId?: string,
  approvalReuseReferenceNo?: string,
  approvalType?: ApprovalType,
  approvalSubType?: string
  hasReferralPreauth?: boolean
  preauthType?: string
  preauthTypeNameEnglish?: string
  preauthTypeNameArabic?: string
  preauthReferenceId?: string
  preauthResponseValue?: string
  preauthResponseUrl?: string
  claimUploadId?: string
  claimUploadName?: string
  processNotes?: IProcessNote[]
  approvalProcessNotes?: IProcessNote[]
  isClaimReimbursement?: boolean
  claimReimbursementRequestId?: string
  pbmePrescriptionReferenceNumber?: string
  pbmStatus?: string
  pbmErrors?: PbmPrescriptionError[],
  isPBMCreated?: boolean,
  isPBMUpdated?: boolean;
  isPBMOverridden?: boolean;
  isPBMCancelled?: boolean;
  reviewAssignedTo?: string,
  reviewAssignedToUserName?: string,
  reviewerRemarks?: string,
  reviewerDecisionStatusId?: string,
  reviewerDecisionStatusNameEnglish?: string,
  reviewerDecisionStatusNameArabic?: string,
  decisionRemark?: string
  communicationFormGroup?: any
  totalAdjudicationTime?: string
  totalBatchProcessedClaim?: number
  totalBatchClaim?: number,
  approvalBatchId?: string,
  approvalBatchIdNo?: string,
  approvalBatchLabel?: string;
  approvalBatchStatusId?: string,
  approvalBatchStatusNameEnglish?: string,
  approvalBatchStatusNameArabic?: string,
  providerBatchId?: string,
  providerBatchIdNo?: string,
  providerBatchLabel?: string,
  providerBatchStatusId?: string,
  providerBatchStatusNameEnglish?: string,
  providerBatchStatusNameArabic?: string,
}
export interface PbmPrescriptionError {
  code?: string;
  description?: string;
}

export interface RelatedRefNo {
  approvalRelatedReferenceDetailId?: string;
  approvalRequestId?: string;
  beneficiaryFullName: string;
  createdBy?: string;
  createdDate?: string;
  relatedApprovalId: string;
  relatedApprovalRefNo: string;
}
export interface IApprovalSupportingInfo {
  approvalSupportingInfoId: string;
  endDate?: string;
  morphology: string;
  morphologyCode: string;
  morphologyNameArabic: string;
  morphologyNameEnglish: string;
  morphologyVariant: string;
  reasonForSupportingInfo?: string;
  reasonForSupportingInfoNameArabic?: string;
  reasonForSupportingInfoNameEnglish?: string;
  seqNo: number;
  startDate?: string;
  supportingInfoType: string;
  supportingInfoTypeDesc: string;
  teethNumber?: string;
  value?: string;
  attachmentId?: string;
}

export interface IApprovalSupportingInfoLabTest {
  code: string;
  descriptionArabic: string;
  descriptionEnglish: string;
  endDate: string;
  loincCodeId: string;
  seqNo: number;
  startDate: string;
  value: string;
}

export interface IApprovalSupportingInfoDiagnosis {
  supportingInfoType: string
  code: string
  seqNo: number
  timing: string
  value: string
  descriptionArabic: string;
  descriptionEnglish: string;
  diagnosisId: string;
  supportingInfoTypeDesc: string;
}

export interface IApprovalAccidentDetail {
  approvalAccidentDetailId?: string,
  approvalRequestId?: string,
  accidentTypeId?: string,
  accidentTypeNameEnglish?: string,
  accidentTypeNameArabic?: string,
  streetName?: string,
  cityId?: string,
  cityNameEnglish?: string,
  cityNameArabic?: string,
  stateId?: string,
  stateNameEnglish?: string,
  stateNameArabic?: string,
  countryId?: string,
  countryNameEnglish?: string,
  countryNameArabic?: string,
  accidentDate?: string,
}

export interface IApprovalVisionPrescription {
  approvalRequestId: string;
  brand: string;
  color: string;
  leftAdd: number;
  leftAxis: number;
  leftBackCurve: string;
  leftCylinder: number;
  leftDiameter: string;
  leftDuration: string;
  leftDurationType: string;
  leftDurationTypeNameArabic: string;
  leftDurationTypeNameEnglish: string;
  leftPower: number;
  leftPrism: number;
  leftPrismBase: string;
  leftPrismBaseNameArabic: string;
  leftPrismBaseNameEnglish: string;
  leftSphere: number;
  notes: string;
  productId: string;
  productNameArabic: string;
  productNameEnglish: string;
  rightAdd: number;
  rightAxis: number;
  rightBackCurve: string;
  rightCylinder: number;
  rightDiameter: string;
  rightDuration: string;
  rightDurationType: string;
  rightDurationTypeNameArabic: string;
  rightDurationTypeNameEnglish: string;
  rightPower: number;
  rightPrism: number;
  rightPrismBase: string;
  rightPrismBaseNameArabic: string;
  rightPrismBaseNameEnglish: string;
  rightSphere: number;
  no?: number | string;
}

export interface IApprovalEncounterInfo {
  approvalEncounterInfoId?: string
  approvalRequestId?: string
  statusId: string
  statusNameEnglish?: string
  statusNameArabic?: string
  classId: string
  classNameEnglish?: string
  classNameArabic?: string
  serviceTypeId: string
  serviceTypeNameEnglish?: string
  serviceTypeNameArabic?: string
  priorityId: string
  priorityNameEnglish?: string
  priorityNameArabic?: string
  startDate: string
  endDate: string
  serviceEventTypeId: string
  serviceEventTypeNameEnglish?: string
  serviceEventTypeNameArabic?: string
  causeofDeath?: string
  causeofDeathDetail?: IDiagnosis
  createdBy?: string
  createdDate?: string
}

export interface IApprovalHospitalizationInfo {
  approvalHospitalizationInfoId?: string
  approvalRequestId?: string
  originId?: string
  originNameEnglish?: string
  originNameArabic?: string
  admitSourceId?: string
  admitSourceNameEnglish?: string
  admitSourceNameArabic?: string
  readmissionId?: string
  readmissionNameEnglish?: string
  readmissionNameArabic?: string
  dischargeDispositionId?: string
  dischargeDispositionNameEnglish?: string
  dischargeDispositionNameArabic?: string
  admissionSpecialityId?: string
  admissionSpecialityCode?: string
  admissionSpecialityNameEnglish?: string
  admissionSpecialityNameArabic?: string
  dischargeSpecialityId?: string
  dischargeSpecialityCode?: string
  dischargeSpecialityNameEnglish?: string
  dischargeSpecialityNameArabic?: string
  intendedLengthofStayId?: string
  intendedLengthofStayNameEnglish?: string
  intendedLengthofStayNameArabic?: string
  createdBy?: string
  createdDate?: string
}

export interface IApprovalEmergencyInfo {
  approvalEmergencyInfoId?: string
  approvalRequestId?: string
  erArrivalCode?: string
  erArrivalCodeNameEnglish?: string
  erArrivalCodeNameArabic?: string
  erServiceStartDate?: string
  erDepartmentDispositionId?: string
  erDepartmentDispositionNameEnglish?: string
  erDepartmentDispositionNameArabic?: string
  triageCategoryId?: string
  triageCategoryNameEnglish?: string
  triageCategoryNameArabic?: string
  triageDate?: string
  createdBy?: string
  createdDate?: string
}

export type ApprovalItem = ToFormControls<IApprovalItem>;

export interface IApprovalItem {
  bodySiteNameArabic: string;
  bodySiteNameEnglish: string;
  bodySubSiteNameArabic: string;
  bodySubSiteNameEnglish: string;
  pharmacistSelectionReasonNameArabic: string;
  pharmacistSelectionReasonNameEnglish: string;
  pharmacistSubstituteNameArabic: string;
  pharmacistSubstituteNameEnglish: string;
  quantityCodeNameArabic: string;
  quantityCodeNameEnglish: string;
  approvedDiscountAmount: string | number;
  approvedNet: string | number
  approvedPatientShareAmount: string | number
  approvedPayerShareAmount: string | number
  approvedQuantity: number
  statusNameArabic: string;
  statusNameEnglish: string;
  approvalItemId: string,
  approvalRequestId: string
  seqNo?: number
  serviceCodeId: string
  nonStandardCode: string
  nonStandardDesc: string
  bodySite: string
  bodySubSite: string
  dentalBodySite: number
  serviceStartDate: string
  serviceEndDate: string
  isPackage: boolean
  isMaternity: boolean
  quantity: number
  quantityCode: string
  unitPrice: number
  taxAmount: number | null
  factor: number
  net: number | null
  discountAmount: number | null
  patientShareAmount: number | null
  patientSharePercent: number | null
  payerShareAmount: number | null
  prescribedDrugCode: Partial<IServiceCode> | null
  pharmacistSelectionReason: string
  pharmacistSubstitute: string
  reasonPharmacistSubstitute: string
  statusId: string
  serviceType?: string,
  reasonNoteId: string
  approvalItemCareTeams: IApprovalItemCareTeam[] | englishArabicName[]
  approvalItemDiagnosis: IApprovalItemDiagnosis[] | englishArabicName[]
  approvalItemSupportingInfos: IApprovalItemSupportingInfo[] | englishArabicName[]
  approvalItemPackageDetails: IApprovalItemPackageDetails[]
  approvalItemDosageDetails: IApprovalItemDosageDetail[]
  approvalItemReasonNotes: ApprovalItemReasonNote[]
  createdBy: string
  createdDate: string
  serviceCode?: ServiceCode;
  invoiceNo?: string;
  absenceofScientificCode?: string;
  absenceofScientificCodeNameArabic?: string;
  absenceofScientificCodeNameEnglish?: string;
  strength?: string
  daysOfSupply?: string
  absenceOfScientificCodeOtherReason?: string
  isItemReAdjudicated?: boolean
  isItemReSubmitted?: boolean
  noteNumbers?: number[]
  approvalItemProcessNotes?: IProcessNote[]
  mreStatus: string
  mreErrors: string,
  pbmStatus: string
  pbmErrors: PbmPrescriptionError[],
  pbmNet?: string;
  pbmDiscount?: string;
  pbmPatientShare?: string;
  pbmAmount?: string;
  pbmDayOfSupply?: string;
  pbmApprovedQuantity?: string;
  pbmApprovedDuration?: string;
  patientShareVatAmountValue?: string;
  overrideReason?: string
  serviceCategory?: string,
  reviewerRemarks?: string
}

export interface IApprovalItemCareTeam {
  approvalPhysicianSeqNo: number
  seqNo: number
}

export interface IApprovalItemDiagnosis {
  approvalDiagnosisSeqNo: number
  seqNo: number
}

export interface englishArabicName {
  nameArabic: string,
  nameEnglish: string
}

export interface IApprovalItemSupportingInfo {
  approvalSupportingInfoSeqNo: number
  approvalSupportingInfoLabTestSeqNo: number
  approvalSupportingInfoDiagnosisSeqNo: number
  seqNo: number
}

export interface IApprovalItemPackageDetails {
  approvalItemPackageDetailId?: string;
  pharmacistSelectionReasonNameArabic: string;
  pharmacistSelectionReasonNameEnglish: string;
  pharmacistSubstituteNameArabic: string;
  pharmacistSubstituteNameEnglish: string;
  quantityCodeNameArabic: string;
  quantityCodeNameEnglish: string;
  seqNo?: number
  serviceCodeId: string
  nonStandardCode: string
  serviceCode?: ServiceCode;
  nonStandardDescription: string
  quantity: number
  quantityCode: string
  prescribedDrugCode: Partial<IServiceCode> | null
  pharmacistSelectionReason: string
  pharmacistSubstitute: string
  reasonPharmacistSubstitute: string,
  approvalItemDosageDetails: IApprovalItemDosageDetail[]
  absenceofScientificCode?: string
  absenceofScientificCodeNameArabic?: string;
  absenceofScientificCodeNameEnglish?: string;
  strength?: string
  approvalItemPackageDosageDetails: IApprovalItemDosageDetail[]
  absenceOfScientificCodeOtherReason?: string
  noteNumbers?: number[]
  approvalItemDetailProcessNotes?: IProcessNote[]
}

export interface IApprovalItemDosageDetail {
  seqNo: number;
  route: string;
  dosageType: string;
  dosageSubType: string;
  quantity?: string | null;
  minQuantity?: string | null;
  maxQuantity?: string | null;
  dosageUnit?: string | null;
  numeratorRatio?: string | null;
  numeratorUnit?: string | null;
  denomenatorRatio?: string | null;
  denomenatorUnit?: string | null;
  startDate: string;
  endDate: string;
  duration: string;
  durationUnit: string;
  frequencyType?: string | null;
  frequency?: string | null;
  frequencyUnit?: string | null;
  period?: string | null;
  periodUnit?: string | null;
  refillCount?: string | null;
  patientInstruction?: string | null;
  additionalNotes?: string | null;
}


export interface ApprovalItemReasonNote {
  approvalReasonNoteId: string
  approvalRequestId: string
  approvalItemId: string
  statusId: string
  statusNameEnglish: string
  statusNameArabic: string
  reasonId: string
  reasonDescriptionEnglish: string
  reasonDescriptionArabic: string
  reasonNote: string
  comment: string
  createdBy: string
  createdDate: string
}

export interface ApprovalReasonNote {
  approvalReasonNoteId: string
  approvalRequestId: string
  approvalItemId: string
  statusId: string
  statusNameEnglish: string
  statusNameArabic: string
  reasonId: string
  reasonDescriptionEnglish: string
  reasonDescriptionArabic: string
  reasonNote: string
  comment: string
  createdBy: string
  createdDate: string
}

export interface IOldReference {
  approvalRequestId: string
  beneficiaryId: string;
  fullName: string
  referenceNo: string
  dateOrdered: string,
}

export interface IPriceListForPreAuth {
  factor: number
  nonStandardCode: string
  nonStandardCodeDesc: string
  priceListId: string
  priceListServiceId: string
  serviceCode: string
  serviceCodeDescriptionArabic: string
  serviceCodeDescriptionEnglish: string
  serviceCodeId: string
  serviceTypeId: string
  serviceTypeNameArabic: string
  serviceTypeNameEnglish: string
  unitPrice: number
}

interface ServiceCode {
  serviceCodeId?: string;
  code: string;
  descriptionEnglish: string;
  descriptionArabic: string;
  grossPrice: number;
  discountinPercentage: number;
  serviceTypeId: string;
  serviceTypeNameEnglish?: string;
  serviceTypeNameArabic?: string;
  standardNameId?: string;
  standardNameEnglish?: string;
  standardNameArabic?: string;
}

export interface IApprovalDiagnosis {
  diagnosisId: string;
  seqNo?: number;
  diagnosisTypeId: string;
  admissionTypeId: string;
  admissionTypeNameArabic: string;
  admissionTypeNameEnglish: string;
  code: string;
  descriptionArabic: string;
  descriptionEnglish: string;
  diagnosisTypeNameArabic: string;
  diagnosisTypeNameEnglish: string;
  conditionOnSetType: string;
  conditionOnSetTypeNameEnglish: string;
  conditionOnSetTypeNameArabic: string;
  mreStatus: string;
  mreErrors: string;
}

export interface IApprovalDiagnosisForm {
  diagnosisId: FormControl<string>;
  seqNo?: FormControl<number>;
  diagnosisTypeId: FormControl<string>;
  admissionTypeId: FormControl<string>;
  approvalDiagnosisId?: FormControl<string>;
  conditionOnSetType: FormControl<string>;
}

export interface IApprovalCareTeamForm {
  approvalCareTeamId?: FormControl<string>;
  physicianId?: FormControl<string>;
  seqNo?: FormControl<number | null>;
  practitionerName?: FormControl<string>;
  careTeamRoleId?: FormControl<string>;
}

export interface IApprovalCareTeam {
  approvalCareTeamId?: string;
  physicianId?: string;
  seqNo?: number;
  practitionerName?: string;
  careTeamRoleId?: string;
  careTeamRoleNameArabic: string;
  careTeamRoleNameEnglish: string;
  createdDate: string;
  deleted: boolean;
  lastUpdatedDate: string;
  nameArabic: string;
  nameEnglish: string;
  physicianUId: string;
  roleId: string;
  roleNameArabic: string;
  roleNameEnglish: string;
  specialityCode: string;
  specialityId: string;
  specialityNameArabic: string;
  specialityNameEnglish: string;
}

export type preauthProcessConst = 'view' | 'process' | 'payment' | 'denial-management';

export interface IRelatedRefNos {
  approvalRelatedReferenceDetailId?: string
  approvalRequestId?: string
  relatedApprovalId: string
  beneficiaryFullName: string
  relatedApprovalRefNo: string
  createdBy?: string
  createdDate?: string
}

export interface ITab {
  label: string,
  isDisabled: boolean,
  isHomePage?: boolean,
  content: Type<unknown>,
  formGroupName?: string,
  tabNumber?: number,
}

export interface ICareTeam {
  approvalCareTeamId: string,
  careTeamRoleId: string,
  careTeamRoleNameEnglish: string,
  careTeamRoleNameArabic: string,
  seqNo: number,
  physicianId: string,
  physicianUId: string,
  nameEnglish: string,
  nameArabic: string,
  specialityId: string,
  specialityCode: string,
  specialityNameEnglish: string,
  specialityNameArabic: string,
  roleId: string,
  roleNameEnglish: string,
  roleNameArabic: string
}
export interface IApprovalItemDosageDetail {
  seqNo: number;
  route: string;
  routeNameEnglish: string;
  routeNameArabic: string;
  dosageType: string;
  dosageTypeNameEnglish: string;
  dosageTypeNameArabic: string;
  dosageSubType: string;
  dosageSubTypeNameEnglish: string;
  dosageSubTypeNameArabic: string;
  quantity?: string;
  minQuantity?: string;
  maxQuantity?: string;
  dosageUnit?: string;
  dosageUnitCode?: string;
  dosageUnitNameEnglish?: string;
  dosageUnitNameArabic?: string;
  numeratorRatio?: string;
  numeratorUnit?: string;
  numeratorUnitCode?: string;
  numeratorUnitNameEnglish?: string;
  numeratorUnitNameArabic?: string;
  denomenatorRatio?: string;
  denomenatorUnit?: string;
  denomenatorUnitCode?: string;
  denomenatorUnitNameEnglish?: string;
  denomenatorUnitNameArabic?: string;
  startDate: string;
  endDate: string;
  duration: string;
  durationUnit: string;
  durationUnitNameEnglish: string;
  durationUnitNameArabic: string;
  frequencyType?: string;
  frequencyTypeNameEnglish?: string;
  frequencyTypeNameArabic?: string;
  frequency?: string;
  frequencyUnit?: string;
  frequencyUnitNameEnglish?: string;
  frequencyUnitNameArabic?: string;
  period?: string;
  periodUnit?: string;
  periodUnitNameEnglish?: string;
  periodUnitNameArabic?: string;
  refillCount?: string;
  patientInstruction?: string;
  additionalNotes?: string;
  approvedDuration?: string;
  approvedRefill?: string;
}

export interface IProcessNote {
  referenceId?: string
  approvalProcessNoteId?: string;
  approvalRequestId?: string;
  approvalItemId?: string;
  approvalItemPackageDetaiId?: string;
  noteTypeId?: string;
  noteTypeCode?: string;
  noteTypeNameEnglish?: string;
  noteTypeNameArabic?: string;
  note?: string;
  noteNumber?: number;
}

export const approvedFieldsKey: { [key: string]: string } = {
  approvedQuantity: 'quantity',
  approvedDiscountAmount: 'discountAmount',
  approvedPatientShareAmount: 'patientShareAmount',
  approvedPayerShareAmount: 'payerShareAmount',
  approvedNet: 'net',
  approvedFactor: 'factor'
};

export const approvedFields: string[] = [
  'approvedQuantity',
  'approvedDiscountAmount',
  'approvedPatientShareAmount',
  'approvedPayerShareAmount',
  'approvedNet',
  'approvedFactor'
];
